// extracted by mini-css-extract-plugin
export var blog = "blog-module--blog--24365";
export var title = "blog-module--title--3ctFu";
export var logo = "blog-module--logo--2TIwp";
export var posts = "blog-module--posts--3VBJh";
export var post = "blog-module--post--qobUY";
export var text = "blog-module--text--26Pj6";
export var meta = "blog-module--meta--1JGT1";